import { useMemo } from "react";

/**
 * Retorna opções para um select com suporte a loading e opção inicial.
 * @param {Object[]} list Lista de objetos { label, value }
 * @param {boolean} loading Estado de carregamento
 * @param {Object} [initialOption] Opção inicial, ex: { label: "Selecionar", value: "" }
 */
export default function useSelectOptions(list, loading, initialOption) {
  return useMemo(() => {
    if (loading) {
      return [<option key="loading">Carregando...</option>];
    }
    const options = list.map(({ label, value }) => (
      <option value={value} key={value}>
        {label}
      </option>
    ));
    return initialOption
      ? [<option value={initialOption.value} key="initial">{initialOption.label}</option>, ...options]
      : options;
  }, [list, loading, initialOption]);
}